"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetRegisterLinkResponseSchema = exports.FleetRegisterLinkLookupSchema = exports.FleetRegisterLinkSchema = void 0;
const zod_1 = require("zod");
/**
 * THE LINK BETWEEN A FLEET ROW AND EVERYTHING WE KNOW ABOUT THE DEVICE.
 *
 * A fleet row is keyed by `deviceId`, which IS the register's `registerId` —
 * the POS checks in under the terminal id the pairing flow stored. The
 * registers table already holds the tenant, the location, the hardware unit
 * and the provisioning code against that id; this is the narrow projection
 * of it the fleet view reads.
 *
 * Every field but `registerId` and `tenantId` is optional: a register created
 * before a given field existed simply has no value for it, and the fleet must
 * render such a row rather than hide it.
 */
exports.FleetRegisterLinkSchema = zod_1.z.object({
    /** The terminal id. Equals the fleet row's `deviceId`. Globally unique. */
    registerId: zod_1.z.string().min(1).max(200),
    tenantId: zod_1.z.string().min(1).max(200),
    locationId: zod_1.z.string().max(200).optional(),
    /** The hardware unit this register is paired to — the join the fleet lacked. */
    deviceUnitId: zod_1.z.string().max(200).optional(),
    /** `RT-XXXX-XXXX`. What the till types in to claim itself. */
    provisionCode: zod_1.z.string().max(64).optional(),
    registerName: zod_1.z.string().max(200).optional(),
    registerStatus: zod_1.z.string().max(64).optional(),
});
exports.FleetRegisterLinkLookupSchema = zod_1.z.object({
    /** Bounded: one page of a fleet, not an unbounded fan-out. */
    deviceIds: zod_1.z.array(zod_1.z.string().min(1).max(200)).min(1).max(200),
});
exports.FleetRegisterLinkResponseSchema = zod_1.z.object({
    links: zod_1.z.array(exports.FleetRegisterLinkSchema),
    /**
     * deviceIds that are genuinely NOT in the index — not paired through the
     * registers table. A definite answer.
     */
    missing: zod_1.z.array(zod_1.z.string()),
    /**
     * deviceIds whose lookup FAILED (throttle, IAM, a row we could not read).
     * NOT the same as `missing`: this is "we do not know", and a caller must
     * not render it as "this device has no register". Defaulted so the field
     * is additive and older callers are unaffected.
     */
    unresolved: zod_1.z.array(zod_1.z.string()).default([]),
});
//# sourceMappingURL=fleetRegisterLink.js.map